// src/router.js

import Router from 'vue-router'
import goTo from 'vuetify/es5/services/goto'

// import HelloWorld from "./components/HelloWorld";
import HelloWorld2 from "./components/HelloWorld2";
import List1 from "./components/List1";
import List2 from "./components/List2";
import PersonalAdd from "./components/WithoutLogin/PersonalAdd";
import OrgAdd from "./components/WithoutLogin/OrgAdd";
import ForgetPW from "./components/WithoutLogin/ForgetPW";
import BindingFb from "./components/WithoutLogin/BindingFb";
import BindingGoogle from "./components/WithoutLogin/BindingGoogle";


import SearchInterpreter from "./components/InterpreterCase/SearchInterpreter";
import ContactInterpreter from "./components/InterpreterCase/ContactInterpreter";
import CaseList from "./components/InterpreterCase/CaseList";
import CaseResponseDept from "./components/InterpreterCase/CaseResponseDept";
import ListInterpreterComment from "./components/InterpreterCase/ListInterpreterComment";
import ListRequestOrgComment from "./components/InterpreterCase/ListRequestOrgComment"

//帳號管理
import AccountList from "./components/Member/AccountList";
import ChangePW from "./components/Member/ChangePW";
import UgrpList from "./components/Member/UgrpList";
import UserList from "./components/Member/UserList";

import ListInterpreterList from "./components/List/ListInterpreterList";
import ListOrganList from "./components/List/ListOrganList";
import ListInterpreterEdit from "./components/List/ListInterpreterEdit";
import ListInterpreterView from "./components/List/ListInterpreterView";
import ListOrganEdit from "./components/List/ListOrganEdit";
import ListOrganView from "./components/List/ListOrganView";
import ListPocketList from "./components/List/ListPocketList";


import ProfileEdit from "./components/System/ProfileEdit";

import ReportInterpreterList from "./components/Report/ReportInterpreterList";
import ReportSystemList from "./components/Report/ReportSystemList";
import InterpreterExportList from "./components/Report/InterpreterExportList";


import ArticleList from "./components/System/articleList";
import Login from "./components/System/Login";
import Dashboard from "./components/System/Dashboard";
import Overview from "./components/System/Overview";

import Test from "./components/System/Test";

import Test01 from "./Test/Test01";
import Test01_2 from "./Test/Test01_2";
import Test02 from "./Test/Test02";
import Test03 from "./Test/Test03";
import Test04 from "./Test/Test04";

import FormEmployer from "./components/Les/FormEmployer";
import FormEmployerDisplay from "./components/Les/FormEmployerDisplay";
import Homework from "./components/Les/Homework";
import StudentQuestionnaire from "./components/Les/StudentQuestionnaire";
import TeacherQuestionnaire from "./components/Les/TeacherQuestionnaire";

import HomeworkDisplay from "./components/Les/HomeworkDisplay";
import LottieTest from "./components/Les/LottieTest";


export default new Router({
    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = 0

        if (to.hash) {
            scrollTo = to.hash
        } else if (savedPosition) {
            scrollTo = savedPosition.y
        }

        return goTo(scrollTo)
    },
    routes: [
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            redirect: '/Overview',
            children: [
                {
                    path: '/Overview',
                    name: 'Overview',
                    component: Overview
                },
                {
                    path: '/searchInterpreter',
                    name: ' / 找通譯',
                    component: SearchInterpreter
                }, {
                    path: '/contactInterpreter',
                    name: ' / 找通譯 / 預約洽詢',
                    component: ContactInterpreter
                },
                {
                    path: '/caseList',
                    name: ' / 案件總覽',
                    component: CaseList
                },
                {
                    path: '/caseResponseDept',
                    name: ' / 案件回覆',
                    component: CaseResponseDept
                },
                {
                    path: '/List1',
                    name: ' / 通譯人才名單',
                    component: List1
                },
                {
                    path: '/List2',
                    name: ' / 機關團體名單',
                    component: List2
                },
                {
                    path: '/HelloWorld2',
                    name: ' / 請填寫通譯案件詳細內容',
                    component: HelloWorld2
                },
                {
                    path: '/HelloWorld3',
                    name: ' / HelloWorld3',
                    component: PersonalAdd
                },
                {
                    path: '/ArticleList',
                    name: ' / 資料維護',
                    component: ArticleList
                },
                {
                    path: '/AccountList',
                    name: ' / 使用者帳號管理',
                    component: AccountList
                },
                {
                    path: '/ChangePW',
                    name: ' / 變更密碼',
                    component: ChangePW
                },

                {
                    path: '/UgrpList',
                    name: ' / 權限群組',
                    component: UgrpList
                },
                {
                    path: '/UserList',
                    name: ' / 申請者審核',
                    component: UserList
                },
                {
                    path: '/ProfileEdit',
                    name: ' / 個人基本資料',
                    component: ProfileEdit
                },
                {
                    path: '/ListInterpreterList',
                    name: ' / 通譯人才名單',
                    component: ListInterpreterList
                },
                {
                    path: '/ListOrganList',
                    name: ' / 機關團體名單',
                    component: ListOrganList
                },
                {
                    path: '/ListInterpreterEdit/:uuid',
                    name: ' / 通譯人才名單',
                    component: ListInterpreterEdit
                },
                {
                    path: '/ListInterpreterView/:uuid',
                    name: ' / 個人基本資料',
                    component: ListInterpreterView
                },
                {
                    path: '/ListOrganEdit/:uuid',
                    name: ' / 機關團體名單',
                    component: ListOrganEdit
                },
                {
                    path: '/ListOrganView/:uuid',
                    name: ' / 個人基本資料',
                    component: ListOrganView
                },
                {
                    path: '/listPocketList',
                    name: ' / 口袋名單',
                    component: ListPocketList
                },
                {
                    path: '/listInterpreterComment',
                    name: ' / 通譯人員個人評價記錄',
                    component: ListInterpreterComment
                },
                {
                    path: '/listRequestOrgComment',
                    name: ' / 需求單位意見回饋記錄',
                    component: ListRequestOrgComment
                },
                {
                    path: '/ReportInterpreterList',
                    name: ' / 通譯人才統計報表',
                    component: ReportInterpreterList
                },
                {
                    path: '/ReportSystemList',
                    name: ' / 系統管理報表',
                    component: ReportSystemList
                },
                {
                    path: '/InterpreterExportList',
                    name: ' / 通譯人才資料',
                    component: InterpreterExportList
                },
                {
                    path: '/Test01',
                    name: 'Search Bus',
                    component: Test01

                },
                {
                    path: '/Test01_2',
                    name: 'Monitor',
                    component: Test01_2

                },
                {
                    path: '/Test02',
                    name: 'Driver List',
                    component: Test02

                },
                {
                    path: '/Test03',
                    name: 'Stop List',
                    component: Test03

                },
                {
                    path: '/Test04',
                    name: 'Vehicle List',
                    component: Test04

                },
                {
                    path: '/FormEmployer/:formKey',
                    name: '因應「COVID-19(武漢肺炎)」防疫期間實聯制登記表',
                    component: FormEmployer
                },
                {
                    path: '/employerDisplay/:phone/:visitDate',
                    name: '因應「COVID-19(武漢肺炎)」防疫期間實聯制登記表查詢',
                    component: FormEmployerDisplay
                }
                ,
                {
                    path: '/Homework/:formKey',
                    name: '居家辦公及自主健康管理登記表',
                    component: Homework
                },
                {
                    path: '/homeworkDisplay/:uuid',
                    name: '居家辦公及自主健康管理登記表',
                    component: HomeworkDisplay
                },
                {
                    path: '/StudentQuestionnaire/:formKey',
                    name: '學習回饋單',
                    component: StudentQuestionnaire
                },
                {
                    path: '/TeacherQuestionnaire/:formKey',
                    name: '標準局校園教學活動問卷調查表',
                    component: TeacherQuestionnaire
                }
            ]
        },


        {
            path: '/Login',
            name: 'Login',
            component: Login
        },
        {
            path: '/PersonalAdd',
            name: '註冊通譯人才名單',
            component: PersonalAdd
        },
        {
            path: '/OrgAdd',
            name: '機關團體註冊',
            component: OrgAdd
        },
        {
            path: '/ForgetPW',
            name: '忘記密碼',
            component: ForgetPW
        },
        {
            path: '/T',
            name: 'Test',
            component: Test
        },
        {
            path: '/BindingFb',
            name: '登入綁定Facebook帳號',
            component: BindingFb

        },
        {
            path: '/BindingGoogle',
            name: '登入綁定Google帳號',
            component: BindingGoogle

        },
        {
            path: '/LottieTest',
            name: 'LottieTest',
            component: LottieTest

        }
    ],
})